import React, { useEffect, useRef, useState } from 'react';
import { useResizeDetector } from 'react-resize-detector';
import { TextOverflowWrapper } from './TextOverflow.styles';
const isTextOverflow = (element) => {
    if (!element)
        return false;
    return element.clientWidth < element.scrollWidth;
};
const getText = (node) => {
    if (['string', 'number'].includes(typeof node))
        return `${node}`;
    if (node instanceof Array)
        return node.map(getText).join('');
    if (typeof node === 'object' && node && 'props' in node) {
        return getText(node.props.children);
    }
};
export const TextOverflow = ({ children }) => {
    const ref = useRef(null);
    const { width } = useResizeDetector({ targetRef: ref });
    const [overflow, setOverflow] = useState(false);
    const title = getText(children);
    useEffect(() => {
        const isOverflown = isTextOverflow(ref.current);
        setOverflow(isOverflown);
    }, [children, width]);
    return (React.createElement(TextOverflowWrapper, { ref: ref, title: overflow ? title : undefined }, children));
};
